export default {"src":"/_next/static/media/stable-icon.c09f0b31.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};